import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './style.scss';
import { Table, Select, Button } from 'antd';
import ExtraChargesActions from '@Actions/configurations/extraChargesAction';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import Helpers from '@Apis/helpers';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

const Loader = () => (
  <div className="tally-integration__loader__wrapper">
    {[...Array(5).keys()].map((item) => (
      <div key={item} className="tally-integration__loader-row">
        <div className="loadingBlock tally-integration__loader__line1" />
        <div className="loadingBlock tally-integration__loader__line2" />
        <div className="loadingBlock tally-integration__loader__line3" />
      </div>
    ))}
    <div className="loadingBlock tally-integration__loader__line-btn1" />
    <div className="loadingBlock tally-integration__loader__line-btn2" />
  </div>
);

const TallyMapSalesCharges = ({
  user,
  tallyConnections,
  connectTenantToTallyLocationLoading,
  setStep,
  getTallyConnectionsLoading,
  stepNumber,
  getCharges,
  getChargeLoading,
  getTallyConnections,
  connectTenantToTallyLocation,
}) => {
  const [procuzyCharges, setProcuzyCharges] = useState([]);
  const [isUserReady, setIsUserReady] = useState(false);
  const integrationTallyIdURL = Number(Helpers.getValueFromUrl('it_id'));

  useEffect(() => {
    const orgId = user?.tenant_info?.org_id;
    if (orgId) {
      getTallyConnections(orgId);
      getCharges(orgId, 'SALES', (chargesData) => setProcuzyCharges(chargesData));
    }
  }, [user, getTallyConnections, getCharges]);

  const tallyConnectionsFilteredData = tallyConnections?.filter((connection) => connection?.it_id === integrationTallyIdURL);

  useEffect(() => {
    if (!tallyConnectionsFilteredData?.[0]?.sales_charge_mappings || !procuzyCharges) return;

    const updatedProcuzyCharges = procuzyCharges.map((charge) => {
      const matchedLedger = tallyConnectionsFilteredData[0]?.sales_charge_mappings?.find(
        (ledger) => ledger.ledger_id === charge.ledger_id
      );

      if (matchedLedger?.ledger_account_name) {
        return { ...charge, ...matchedLedger };
      }
      return charge;
    });

    const hasChanges = JSON.stringify(updatedProcuzyCharges) !== JSON.stringify(procuzyCharges);

    if (hasChanges && !isUserReady) {
      setProcuzyCharges(updatedProcuzyCharges);
      setIsUserReady(true);
    }
  }, [tallyConnectionsFilteredData]);

  const updateTableValue = (key, value, label) => {
    setProcuzyCharges((prevCharges) => prevCharges?.map((item) => (item.ledger_id === key ? { ...item, [label]: value } : item)));
  };

  const handleSubmit = () => {
    const salesChargeMapping = procuzyCharges?.map(({ ledger_id, ledger_name, ledger_account_name }) => ({
      ledger_id,
      ledger_name,
      ledger_account_name: ledger_account_name || null,
    }));

    const payload = {
      ...tallyConnectionsFilteredData[0],
      sales_charge_mappings: salesChargeMapping,
    };

    connectTenantToTallyLocation(payload, () => setStep(stepNumber + 1));
  };

  const renderTallyLedger = (record) => (
    <PRZSelect
      onChange={(value) => updateTableValue(record.ledger_id, value, 'ledger_account_name')}
      value={record.ledger_account_name}
      disabled={getChargeLoading || connectTenantToTallyLocationLoading}
      showSearch
      allowClear
      filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
      placeholder=""
    >
      {tallyConnectionsFilteredData?.[0]?.ledger_account_list?.map((item) => (
        <Option value={item.ledger_account_name} key={item.ledger_account_name}>
          {item?.ledger_account_name}
        </Option>
      ))}
    </PRZSelect>
  );

  const columns = [
    {
      title: 'Procuzy Charges',
      dataIndex: 'ledger_name',
      key: 'ledger_name',
      width: '312px',
    },
    {
      title: 'Tally Ledger',
      key: 'tally_ledger',
      render: renderTallyLedger,
    },
  ];

  if (getTallyConnectionsLoading) {
    return <Loader />;
  }

  return (
    <div>
      <div className="integration-step__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-18">
            <Table
              title={() => 'Map sales charges of Procuzy with Tally'}
              columns={columns}
              dataSource={procuzyCharges || []}
              size="small"
              pagination={false}
              loading={getTallyConnectionsLoading || getChargeLoading || connectTenantToTallyLocationLoading}
            />
          </div>
        </div>
      </div>
      <div className="integration-step__footer" style={{ display: 'flex', paddingTop: '10px', paddingLeft: '15px' }}>
        <Button type="primary" ghost onClick={() => setStep(7)} disabled={connectTenantToTallyLocationLoading}>
          Back
        </Button>
        &nbsp;&nbsp;
        <Button type="primary" onClick={handleSubmit} loading={connectTenantToTallyLocationLoading}>
          Save and Continue
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TallyIntegrationReducers, ExtraChargesReducers,
}) => ({
  user: UserReducers.user,
  tallyConnections: TallyIntegrationReducers.tallyConnections,
  connectTenantToTallyLocationLoading: TallyIntegrationReducers.connectTenantToTallyLocationLoading,
  getChargeLoading: ExtraChargesReducers.getChargeLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCharges: (orgId, entityName, callback) => dispatch(ExtraChargesActions.getCharges(orgId, entityName, callback)),
  getTallyConnections: (orgId, callback) => dispatch(TallyIntegrationActions.getTallyConnections(orgId, callback)),
  connectTenantToTallyLocation: (payload, callback) => dispatch(TallyIntegrationActions.connectTenantToTallyLocation(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallyMapSalesCharges));
